var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-app-bar',{attrs:{"dense":"","app":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-drawer')}}}),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$lang(_vm.pageTitle ? _vm.pageTitle : "APP_TITLE")))]),_c('v-spacer'),_c('context-button')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }